import { render, staticRenderFns } from "./organTree.vue?vue&type=template&id=ce3fc916&"
import script from "./organTree.vue?vue&type=script&lang=js&"
export * from "./organTree.vue?vue&type=script&lang=js&"
import style0 from "./organTree.vue?vue&type=style&index=0&id=ce3fc916&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports